<div class="p-dialog-content__dynamic">
  <form action="" [formGroup]="form">
    <div class="form-row w-100">
      <div class="auto-complete form-element w-100">
        <label
          class="form-label"
          [class.required]="
            form.get('product')?.hasValidator(Validators.required)
          "
        >
          Select Product To Copy Milestones From:
        </label>
        <p-autoComplete
          class="w-100"
          formControlName="product"
          [multiple]="false"
          (completeMethod)="productFilter.onQueryChange($event)"
          (onSelect)="productFilter.onSelected($event)"
          [suggestions]="productFilter.suggestions"
          [completeOnFocus]="true"
          field="label"
          placeholder="Search To Select Product"
          appendTo="body"
          (onShow)="productFilter.paginationScrolling()"
        >
        </p-autoComplete>
        <app-form-errors
          [color]="'product'"
          [form]="form"
          [control]="form.get('product')"
        >
        </app-form-errors>
      </div>
    </div>
  </form>
</div>

<div class="p-dialog-footer p-dialog-footer__dynamic">
  <button class="cancel-btn medium" (click)="cancelClicked()">Cancel</button>
  <button
    class="regular-btn medium"
    (click)="saveClicked()"
    [disabled]="isSubmitLoading"
  >
    Save
    <i *ngIf="isSubmitLoading" class="fa-spin fas fa-spinner ms-2"></i>
  </button>
</div>
